export const obtenerSeccion = (camino) => {

    let seccion = camino.split('/')[1]

    return seccion
}